import React from "react";
import BtnMedium from "./BtnMedium";
import {Modal} from "react-bootstrap";

function ConfirmModal({ show, sentence, cancelText, confirmText, onClick, dismiss }) {

  return (
  <Modal show={show} dialogClassName="confirm-modal">
    <Modal.Body>{sentence}</Modal.Body>
    <Modal.Footer>
      <BtnMedium type="button" color="black" text={cancelText} onClick={dismiss}/>
      <BtnMedium type="button" color="blue" text={confirmText} onClick={onClick}/>
    </Modal.Footer>
  </Modal>
  );
}

export default ConfirmModal;
